// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** Instructor page ****/

.instructor-filters {
  margin: 20px 0 57px 20px;
}

.instructor-filters a.selected {
  font-weight: 600;
}

.instructor-filters a.choice {
  color: #232021;
  font-size: 14px;
}

.instructor-filter-by {
  color: #232021;
  font-size: 14px;
  font-weight: 600;
  padding-right: 20px;
}

.instructor-offering-container img {
  margin: 12px 0;
  width: 100%;
}

.instructor-offering-detail-container {
  font-size: 12px;
  margin: 35px 0 24px 0;
}

.instructor-offering-detail-half div {
  margin-bottom: 2px;
}

.instructor-offering-detail-half.col-md-7,
.instructor-offering-detail-half.col-md-5 {
  padding: 0px;
}

.instructor-offering-detail-type {
  display: inline-block;
  font-weight: 600;
  width: 90px;
}
.semi-b {
  font-weight: 600;
}

.instructor-offering {
  margin-right: 10px;
  padding: 15px 10px 17px 10px;
  width: 100%;
}
.instructor-offering-location {
  position: relative;
  top: -3px;
}

.instructor-title-text {
  font-size: 16px;
  font-weight: 600;
}
.instructor-date-text {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.tile .instructor-date-text img {
  float: right;
  height: 20px;
  margin: 0px;
  width: 20px;
}

.pipe {
  color: #232021;
  padding: 0 15px;
}

.filterBy .filterItem + .filterItem:before {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/instructor/instructor.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":["/**** Instructor page ****/\n\n.instructor-filters {\n  margin: 20px 0 57px 20px;\n}\n\n.instructor-filters a.selected {\n  font-weight: 600;\n}\n\n.instructor-filters a.choice {\n  color: #232021;\n  font-size: 14px;\n}\n\n.instructor-filter-by {\n  color: #232021;\n  font-size: 14px;\n  font-weight: 600;\n  padding-right: 20px;\n}\n\n.instructor-offering-container img {\n  margin: 12px 0;\n  width: 100%;\n}\n\n.instructor-offering-detail-container {\n  font-size: 12px;\n  margin: 35px 0 24px 0;\n}\n\n.instructor-offering-detail-half div {\n  margin-bottom: 2px;\n}\n\n.instructor-offering-detail-half.col-md-7,\n.instructor-offering-detail-half.col-md-5 {\n  padding: 0px;\n}\n\n.instructor-offering-detail-type {\n  display: inline-block;\n  font-weight: 600;\n  width: 90px;\n}\n.semi-b {\n  font-weight: 600;\n}\n\n.instructor-offering {\n  margin-right: 10px;\n  padding: 15px 10px 17px 10px;\n  width: 100%;\n}\n.instructor-offering-location {\n  position: relative;\n  top: -3px;\n}\n\n.instructor-title-text {\n  font-size: 16px;\n  font-weight: 600;\n}\n.instructor-date-text {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tile .instructor-date-text img {\n  float: right;\n  height: 20px;\n  margin: 0px;\n  width: 20px;\n}\n\n.pipe {\n  color: #232021;\n  padding: 0 15px;\n}\n\n.filterBy .filterItem + .filterItem:before {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
